import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import AdminDashboard from './AdminDashboard';
import Login from './Login'; // Existing Member Login
import BidderDashboard from './BidderDashboard'; // NEW
import ResidentDashboard from './ResidentDashboard';
import MobileCheckout from './MobileCheckout';
import AdminLedger from './AdminLedger';
import AdminManualPayment from './AdminManualPayment';
import AdminContacts from './AdminContacts';
import AdminMessages from './AdminMessages';
import TermsAndConditions from './TermsAndConditions';
import PrivacyPolicy from './PrivacyPolicy';
import ContactUs from './ContactUs';
import DeveloperAd from './DeveloperAd';
import RefundPolicy from './RefundPolicy';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Home */}
        <Route path="/" element={<Home />} />
        
        {/* Member/Admin Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/resident-dashboard" element={<ResidentDashboard />} />
        <Route path="/mobile-checkout" element={<MobileCheckout />} />
        <Route path="/admin/ledger" element={<AdminLedger />} />
        <Route path="/admin/manual-payment" element={<AdminManualPayment />} />

        {/* Bidder Auth & Dashboard */}
       
        <Route path="/bidder-dashboard" element={<BidderDashboard />} />
        <Route path="/admin/contacts" element={<AdminContacts />} />
        <Route path="/admin/messages" element={<AdminMessages />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/developer-ad" element={<DeveloperAd />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        
      </Routes>
    </Router>
  );
}

export default App;